import { render } from "./TableItemsPerPageSelect.vue?vue&type=template&id=e1522ef6&ts=true"
import script from "./TableItemsPerPageSelect.vue?vue&type=script&lang=ts"
export * from "./TableItemsPerPageSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__